'use strict';

/*
function fingerprintCanvas() {
  try {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ`~1!2@3#4$5%6^7&8*9(0)-_=+[{]}|;:',<.>/?", 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ`~1!2@3#4$5%6^7&8*9(0)-_=+[{]}|;:',<.>/?", 4, 17);

    return canvas.toDataURL();
  } catch (error) {
    return error;
  }
}
*/

function fingerprintCalculate(key) {
  var remainder = key.length & 3; // key.length % 4
  var bytes = key.length - remainder;
  var c1 = 0xcc9e2d51;
  var c2 = 0x1b873593;

  var h1;
  var h1b;
  var k1;

  for (var i = 0; i < bytes; i++) {
    k1 = ((key.charCodeAt(i) & 0xff)) | ((key.charCodeAt(++i) & 0xff) << 8) | ((key.charCodeAt(++i) & 0xff) << 16) | ((key.charCodeAt(++i) & 0xff) << 24);
    ++i;

    k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
    k1 = (k1 << 15) | (k1 >>> 17);
    k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

    h1 ^= k1;
    h1 = (h1 << 13) | (h1 >>> 19);
    h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
    h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
  }

  i = bytes - 1;

  k1 = 0;

  switch (remainder) {
    case 3: {
      k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
    }

    break;
    case 2: {
      k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
    }

    break;
    case 1: {
      k1 ^= (key.charCodeAt(i) & 0xff);
    }

    break;
  }

  k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
  k1 = (k1 << 15) | (k1 >>> 17);
  k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
  h1 ^= k1;

  h1 ^= key.length;

  h1 ^= h1 >>> 16;
  h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
  h1 ^= h1 >>> 13;
  h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
  h1 ^= h1 >>> 16;

  return h1 >>> 0;
}

function fingerprintSource(hardwareOnly) {
  var userAgent = window.navigator.userAgent;
  var language = window.navigator.language;
  var languages = window.navigator.languages;
  var platform = window.navigator.platform;
  var hardwareConcurrency = window.navigator.hardwareConcurrency;
  var deviceMemory = window.navigator.deviceMemory;

  var plugins = Object.entries(window.navigator.plugins).map(function (plugin) {
    return plugin.name;
  });

  var colorDepth = window.screen.colorDepth;
  var availWidth = window.screen.availWidth;
  var availHeight = window.screen.availHeight;

  var timezoneOffset = new Date().getTimezoneOffset();
  var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var touchSupport = 'ontouchstart' in window;
  var canvas = ''; //fingerprintCanvas();

  var source1 = {
    platform: platform,
    hardwareConcurrency: hardwareConcurrency,
    deviceMemory: deviceMemory,
    colorDepth: colorDepth,
    availWidth: availWidth,
    availHeight: availHeight,
    touchSupport: touchSupport,
    canvas: canvas
  };

  var source2 = {
    userAgent: userAgent,
    language: language,
    languages: languages,
    platform: platform,
    hardwareConcurrency: hardwareConcurrency,
    deviceMemory: deviceMemory,
    plugins: plugins,
    colorDepth: colorDepth,
    availWidth: availWidth,
    availHeight: availHeight,
    timezoneOffset: timezoneOffset,
    timezone: timezone,
    touchSupport: touchSupport,
    canvas: canvas
  };

  return hardwareOnly ? source1 : source2;
}

/*exported fingerprint */
function fingerprint(hardwareOnly) {
  var source = fingerprintSource(hardwareOnly);
  var data = JSON.stringify(source);

  return fingerprintCalculate(data);
}

/*exported fingerprintData */
function fingerprintData(hardwareOnly) {
  var source = fingerprintSource(hardwareOnly);

  return {
    fingerprint: fingerprint(hardwareOnly),
    source: source,
    userAgent: source.userAgent,
    language: source.language,
    platform: source.platform,
    hardwareConcurrency: source.hardwareConcurrency,
    deviceMemory: source.deviceMemory,
    availWidth: source.availWidth,
    availHeight: source.availHeight,
  };
}
